module.exports = __webpack_public_path__ + "img/News_item_9.a3af69c7.jpg";